import {
  AntimalwareSettingsExclusionsItem,
  AntimalwareSettingsExclusionsModuleType,
} from '@nirvana/shared/dtos/types/policies/common';
import { getAvailableModuleOptionsByType } from './configs';

export function convertOldModuleExclusionToNewOne(exclusion: {
  taskType: number;
  path: string;
  module: string | number[];
  remarks: string;
}): AntimalwareSettingsExclusionsItem {
  let modules;

  if (typeof exclusion.module === 'string') {
    if (exclusion.module.indexOf(',') === -1) {
      modules = exclusion.module.split('').map(module => parseInt(module, 10));
    } else {
      modules = exclusion.module.split(',').map(module => parseInt(module, 10));
    }
  }

  if (
    modules.includes(AntimalwareSettingsExclusionsModuleType.ALL) ||
    modules.includes(AntimalwareSettingsExclusionsModuleType.PROCESS_ALL)
  ) {
    modules = getAvailableModuleOptionsByType(exclusion.taskType, false); // without restrictions
  }

  return {
    ...exclusion,
    module: modules,
  };
}
